/**
 * Creates a standard list headers configuration for data tables.
 * This utility function eliminates code duplication by generating the common structure
 * used across multiple header files (owners, pensioners, etc.).
 * @function
 *
 * @param {Object} options - Configuration options
 * @param {string} options.statusKey - The key for the status field (e.g., 'owner_status', 'pensioner_status')
 * @param {string} options.nameFieldsType - Type of name fields: 'standard' (last_name, first_name) or 'pensioner' (principal_pensioner, secondary_pensioner)
 * @returns {Array} Array of header configuration objects
 */
export const createListHeaders = ({
  statusKey = 'status',
  nameFieldsType = 'standard'
}) => {
  const nameFields =
    nameFieldsType === 'pensioner'
      ? [
          {
            label: 'principal_pensioner',
            key: 'principal_pensioner'
          },
          {
            label: 'secondary_pensioner',
            key: 'secondary_pensioner'
          }
        ]
      : [
          {
            label: 'last_name',
            key: 'last_name'
          },
          {
            label: 'first_name',
            key: 'first_name'
          }
        ];

  return [
    {
      label: 'reference',
      key: 'reference'
    },
    ...nameFields,
    {
      label: 'address.city',
      key: 'address.city'
    },
    {
      label: 'address.postal_code',
      key: 'address.postal_code'
    },
    {
      label: 'address.state',
      key: 'address.state'
    },
    {
      label: 'phone_number.number',
      key: 'phone_number.number'
    },
    {
      label: 'cell_phone_number.number',
      key: 'cell_phone_number.number'
    },
    {
      label: 'email',
      key: 'email'
    },
    {
      label: 'status',
      key: statusKey
    }
  ];
};
